import { Panel } from '@atlaskit/navigation-system/layout/panel';
import { Box, xcss } from '@atlaskit/primitives';

import { HelpContents } from './help-contents';
import { useHelpStore } from './help-provider';

export const HelpPanel = () => {
	const { isOpen } = useHelpStore();

	return (
		isOpen && (
			<Panel testId="in-product-help-panel">
				<Box xcss={helpBorderStyles}>
					<HelpContents />
				</Box>
			</Panel>
		)
	);
};

const helpBorderStyles = xcss({
	position: 'relative',
	borderInlineStartStyle: 'solid',
	borderInlineStartColor: 'color.border',
	borderInlineStartWidth: 'border.width',
	height: '100%',
});
